import {useEffect, useRef, useState} from "react";
import {KatBox, KatButton, KatInput, KatModal} from "@amzn/katal-react";
import * as React from "react";
import {EventEmitter} from "events";
import reviewDecisionStore from "src/app/store/ReviewDecisionStore";

interface ReOpenInputDialogProps {
    openDialogEvent: string;
    closeDialogEvent: string;
    eventBus: EventEmitter;
}

const ReOpenInputDialog = (props: ReOpenInputDialogProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const [ticketId, setTicketId] = useState("");
    const {eventBus} = props;

    const ticketIdRef = useRef<any>(null);

    useEffect(() => {
        const handleOpenDialog = (isOpen: any) => {
            if (isOpen) {
                setIsOpen(true);
            }
        }

        eventBus.on(props.openDialogEvent, handleOpenDialog);
        return () => {
            eventBus.removeListener(props.openDialogEvent, handleOpenDialog);
        };
    }, []);

    const handleTicketChange = () => {
        setTicketId(ticketIdRef.current?.value || "");
    };

    const onConfirmationCancel = () => {
        setTicketId("");
        setIsOpen(false);
    }

    const onConfirmationSubmit = async () => {
        // Guard against programmatic clicks; the button is disabled while empty.
        if (!ticketId.trim()) {
            return;
        }
        const newValue = {
            ...reviewDecisionStore.value,
            appealTicket: ticketId.trim()
        }
        reviewDecisionStore.updateValue(newValue);
        setTicketId("");
        setIsOpen(false);
        eventBus.emit(props.closeDialogEvent, true);
    }

    return (
        <KatModal visible={isOpen} data-testid='kat-modal' onClose={onConfirmationCancel}>
            <span slot="title">Confirmation</span>
            <KatBox>
                <KatInput label='Ticket Id *' className='ticket-input' ref={ticketIdRef} data-testid='ticket-id-input'
                          required={true}
                          value={ticketId}
                          onChange={handleTicketChange}
                          onKeyup={handleTicketChange}
                          onInput={handleTicketChange}
                ></KatInput>
            </KatBox>
            <div slot="footer" className="kat-group-horizontal">
                <KatButton variant={"secondary"} label={"Cancel"}
                           onClick={onConfirmationCancel} data-testid='cancel-btn'></KatButton>
                <KatButton label={"Submit"} onClick={onConfirmationSubmit}
                           disabled={!ticketId.trim()} data-testid='submit-btn'></KatButton>
            </div>
        </KatModal>
    );
};

export default ReOpenInputDialog;
